export default {
  init() {
    setTimeout(() => {
      document.querySelector('.loader').classList.add('hidden');
    }, 2000);

    let intervalId = 0;
    const scrollButton = document.querySelector('.scroll');

    function scrollStep() {
      if (window.pageYOffset === 0) {
          clearInterval(intervalId);
      }

      window.scroll(0, window.pageYOffset - 50);
    }

    scrollButton.addEventListener('click', () => {
      intervalId = setInterval(scrollStep, 6.66);
    });

    let pos = 0;
    let ticking = false;

    window.addEventListener('scroll', () => {
      pos = window.scrollY;

      if (ticking) {
        return;
      }

      window.requestAnimationFrame(() => {
        if (pos > 600) {
          if (!scrollButton.classList.contains('opacity-100')) {
            scrollButton.classList.add('opacity-100');
          }
        } else {
          scrollButton.classList.remove('opacity-100');
        }

        ticking = false;
      });

      ticking = true;
    });

    if (!location.search.includes('item=')) {
      return;
    }

    const id = location.search.replace (/[^\d.]/g, '');
    const el = document.querySelector(`.product-${id}`);

    setTimeout(() => {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js